export const statPreprocessor = {
    "stats.penalty.totalYards": (value) => Math.abs(value)
};
